import React, { useEffect } from "react";
import ModalComponent from "../../../../../core/layouts/main/components/Modal";
import { FeeController } from "../../../../../core/config/controllers/FeeController";
import { toast } from "react-toastify";
import Field from "../../../../../core/layouts/main/components/Field";
import { FieldHelper } from "../../../../../core/config/helpers/FieldHelper";
import { AccountHelper } from "../../../../../core/config/helpers/AccountHelper";
import { TermController } from "../../../../../core/config/controllers/TermController";

export default function TermModal({show, onHide, infos}) {
    const [data, setData] = React.useState(infos);

    useEffect(() => {
        if (infos && infos.id) {
            setData(infos);
        } else {
            setData({});
        }
    }, [infos, show]);


    async function save() {
        if(data.id){
            await TermController.Update(data)
            toast("Taxa atualizada com sucesso!");
            onHide();
        }else{
            TermController.Insert(data, (res) => {
                toast("Taxa criada com sucesso!");
                onHide();
            })
        }

    }

    function handleChange(e, type) {
        setData(FieldHelper.OnDataChange(data, e, type));
    }

    return (
        <ModalComponent
            show={show}
            title={data.id ? "Editar Termos" : "Criar Termos"}
            onHide={() => onHide()}
            onSubmit={() => save()}>
            
            <Field title="Nome" name={"name"} value={data.name} onChange={(e) => handleChange(e)} />
            <Field 
                name={"level"} 
                value={data.level} 
                type={FieldHelper.FieldTypeObj.Select}
                options={AccountHelper.LevelList}
                nameOption={"name"}
                keyOption={"value"}
                title="Nível de acesso" 
                onChange={(e) => handleChange(e, FieldHelper.FieldTypeObj.Number)} />

            <Field 
                title="Termo" 
                name={"content"} 
                value={data.content}
                type={FieldHelper.FieldTypeObj.TextArea}
                hint={"Descreva o conteúdo do documento"}
                onChange={(e) => handleChange(e)} />

        </ModalComponent>
    )
}